const EVENT_SKILL_LEVEL_META = Object.freeze({
  1: {
    key: "beginner",
    defaultLabel: "Beginner",
    iconSrc: "/assets/events/beginner.svg",
  },
  2: {
    key: "intermediate",
    defaultLabel: "Intermediate",
    iconSrc: "/assets/events/intermediate.svg",
  },
  3: {
    key: "advanced",
    defaultLabel: "Advanced",
    iconSrc: "/assets/events/advanced.svg",
  },
});

export const getEventSkillLevelMeta = (value) =>
  EVENT_SKILL_LEVEL_META[Number(value)] || null;

export const getEventSkillLevelPresentation = (value, t) => {
  const meta = getEventSkillLevelMeta(value);
  if (!meta) return null;

  const levelLabel = t(`event_create.audience_filters.skill_levels.${meta.key}`, {
    defaultValue: meta.defaultLabel,
  });

  return {
    ...meta,
    levelLabel,
    label: t("events.details.required_skill_level", {
      defaultValue: "Skill level: {{level}}",
      level: levelLabel,
    }),
  };
};
